// import "./App.css";
import { useNavigate } from "react-router-dom";
import LogoOfPrism from "../../Assets/Images/client_logos/landing/Prismlogo.png";
// import ItemPathFilter from "./components/FilterSidebar/ItemPathFilter";
import BlockerZ from "../BlockerZ/BlockerZ";
import Favorites from "./components/Favorites/Favorites";
// import ActionButton from "./components/ActionButton";
// import logo from "./assets/dslogo.png";
// import img from "../../Assets/Images/Landing/training.png";
// import CoachingBuddyImg from "../../Assets/NewCoachingBuddyimg.png"
import CoachingBuddyImg from "../../Assets/NewLogo.png";
import { useEffect, useState, useRef } from "react";
// import { useEffect, useState, useRef } from "react";
import Dropdown from "./components/Dropdown/Dropdown";
import HelpDropdown from "./components/Dropdown/HelpDropdown";
import BranchDropdown from "./components/Dropdown/BranchDropdown";
import Sidebar from "./components/Sidebar/Sidebar";
import CreateRole from "../CreateRole/CreateRole";
import EmployeeRegistration from "../EmployeeRegistration/RegistrationForm";
import StudentRegistration from "../StudentRegistration/StudentRegistrationForm";
import LocationIcon from "../../Assets/Images/CommanImages/location.png";
import DPPPerformance from "../Reports/DPPPerformance/DPPPerformance";
import DPPSubjectCount from "../Reports/BatchSubjectwiseDPPCount/BatchSubjectCount";
import ClassFeedback from "../Reports/ClassFeedback/ClassFeedback";
// import ReportWhatsapp from "../SendReportToParents/ReportWhatsapp";
// import OnlyDown from "../../Assets/Images/CommanImages/downOnly.png";
// import StarSquare from "../../Assets/Images/CommanImages/starSquare.png";
import Search from "../../Assets/Images/CommanImages/searchyellow.png";
import QuestionSecondPage from "../Parser/QuestionSecondPage";
import { Routes, Route, Link } from "react-router-dom";
import StudentLogo from "./../../Assets/Images/CommanImages/studentforsearch.png";
// redux store
import { useSelector } from "react-redux";
// import { ManageRole } from "../ManageRole/ManageRole";
import { useDispatch } from "react-redux";
import { fetchApiData } from "../../Redux/features/Landing/landingSlice";
import AssignUserToRole from "../AssignUserToRole/AssignUserToRole";
import UserSettings from "../UserSettings/UserSettings";
import Profile from "../Profile/Profile";
import AssignDPP from "../AssignTest/Assigntest";
import CreateBatch from "../CreateBatch/CreateBatch";
import UploadQuestions from "../UploadQuestions/UploadQuestions";
import UserReg from "../UserReg/UserReg";
import Home from "../Home/Home";
import AttendanceReport from "../Reports/DummyReportPage/AttendanceReport";
import AssignTest from "../ScheduleTest/ScheduleTest";
import NewTestSeries from "../CreateNTS/newTestSeries";
import GenerateOTLC from "../OTC/OTC";
// import AssignTest from "../AssignTest/Assigntest";
import UOD from "../UploadOmrData/UOD";
// import CreateBatchv2 from "../AssignBatch/CreateBacthV2";
import CreateBatchV2 from "../CreateBatchV2/CreateBacthV2";
import UserManagement from "../UserManagement/UserManagement";
// import { API_BASE_URL } from "../../Config/Config"
import Pop from "../POP/pop";
import TestCreate from "../TestCreate/TestCreate";
import QuestionPaperCorrection from "../QuestionPaperCorrection/QuestionPaperCorrection";
import TimeTable from "../ClassTimeTableSchedule/TimeTable";
import StudentFees from "../StudentsFees/StudentFee";
import ReportManagement from "../ReportManagement/ReportManagement";
import ReportCard from "../ReportCard/ReportCard";
import { API_BASE_URL } from "../../Config/Config";
// import ReportFeatures from "../ReportManagement/ReportFeatures ";
import TestReportCard from "../Reports/TestReportCard/TestReportCard";
// import SecondTableCompoenent from "../Reports/TestReportCard/SecondTableCompoenent";
import ReportWhatsapp from "../SendReportToParents/ReportWhatsapp";
import DppBatchSubwiseStatus from "../Reports/DppBatchSubwiseStatus/DppBatchSubwiseStatus";
import GenerateResult from "../GenerateResult/GenerateResult";
import DPPSummary from "../Reports/StudentDppSummary/StudentDPPSummary";
import StudentDashBoard from "../StudentDashboard/studentdashboard";
import CreateTestSection from "../TestModule/CreateTestSection";
import TestSectionManagement from "../TestSectionManagement/TestSectionManagement";
import NTSV2 from "../CreateNTS-V2/ntsv2";
import TSD from "../TestSeriesDashboard/TSD";
import ParseQuestionDashboard from "../Parser/QuestionDashboard/QuestionDashboard";
import ParseDeleteQuestionDashboard from "../Parser/QuestionDashboard/DeleteQuestionDashboard";
import ReviewerDashboard from "../Parser/ReviewerDashboard/Facultyv2Dashboard";
import HoDDashboard from "../Parser/HODDashboard/HODv2Dashboard";
import HoDv2Dashboard from "../Parser/HODDashboard/HODv2Dashboard";
import QuestionBank from "../Parser/QuesBankDashboard/QuestionBank";
// import ParseBulkQuestion from "../Parser/ParseBulkQuestions/ParseBulkQuestion";
// import ReviewQuestion from "../Parser/ParseQuestionReview/ReviewQuestion"
import ReviewQuestion from "../Parser/ReviewQuestion/ReviewQuestion";
import PublishSingleQuestion from "../Parser/PublishSingleQuestion/PSQMainFile";
import POP2 from "../POP/pop2";
import POP3 from "../POP/pop3";
import ParseBulkQuestion from "../Parser/ParseBulkQuestions/ParseBulkQuestion";
import LevelReview from "../Parser/LevelReview/LevelReview";
import SearchBarStudent from "./SearchBarStudent";
import TESTRQ from "../Parser/ReviewQuestion/TESTRQ";
import CreateQuesPaper from "../../Pages/CreateQuestionsPaper/CurateQuestionPaper/CreateQuesPaper";
import FacultyReview from "../Parser/FacultyReview/FacultyReview";

import QuestionPaperDetail from "../CreateQuestionsPaper/QuestionPaperDetails/QuestionPaperDetail";
import Success from "../../Assets/Images/CommanImages/success.png";
import HodReview from "../Parser/HodReview/HodReview";
import QuestionBankReview from "../Parser/QuestionBankReview/QuestionBankReview";
import DashboardCreateQuestionpaper from "../CreateQuestionsPaper/DashboardCreateQuestionpaper/DashboardCQP";
import QuestionPaperDashboard from "../CreateQuestionsPaper/QuestionPaperDashboard/QuestionPaperDashboard";
import Facultyv2Dashboard from "../Parser/ReviewerDashboard/Facultyv2Dashboard";
// import HODv2Dashboard from "../Parser/HODDashboard/HODv2Dashboard";
import TestScheduling from "../CreateQuestionsPaper/TestScheduling/TestScheduling";
import DppScheduling from "../CreateQuestionsPaper/DppScheduling/DppScheduling";
import DPPDashboardSchedule from "../CreateQuestionsPaper/DPPDashboard/DppDashboard";
import TestDashboardSchedule from "../CreateQuestionsPaper/TestDashboardSchedule/TestDashboardSchedule";

// import DPPScheduleClone from "../CreateQuestionsPaper/DppScheduling/DPPScheduleClone";
import DPPScheduleEdit from "../CreateQuestionsPaper/DppScheduling/DPPScheduleEdit";
import DPPDashboardSchedulev2 from "../Scheduling/DPP/DPPScheduleDashboard";
import AssignorDashbord from "../CreateQuestionsPaper/AssignorDashboard/AssignorDashbord";
import CurateQuestionPaperEdit from "../CreateQuestionsPaper/CurateQuestionPaperEdit/CurateQuestionPaperEdit";
import ReviewerQuesPaperDashboard from "../CreateQuestionsPaper/ReviewerQuesPaperDashboard/ReviewerQuesPaperDashboard";
import TestPaperBonusCorrection from "../TestPaperBonusCorrection/TestPaperBonusCorrection";
import PreviewQuesPaper from "../CreateQuestionsPaper/PreviewQuesPapers/PreviewQuesPaper";
import TestScheduleview from "../CreateQuestionsPaper/TestScheduling/TestScheduleClone";
import RevieweQuestionPaper from "../CreateQuestionsPaper/ReviewQuestionPaper/ReviewQuestionPaper";
import TestResultDashboard from "../TestResultDashboard/TestResultDashboard";
import UploadOmrV2 from "../UploadOmrData/UploadOmrV2";
import StudentGroup from "../StudentGrouph/StudentGroup";
import StudentGroupDashboard from "../StudentGrouph/StudentGroupDashboard";
// import UserDashboard from "../UserDashboard/UserDashboard";
import UserEditFromDashboard from "../UserDashboard/UserEditFromDashboard/UserEditFromDashboard";
// import TestMarkCorrection from "../"
// import UserGroupsDashboard from "../UserGroups/UserGroupsDashboard";
import UserGroupsFromDashboard from "../UserGroups/UserGroupfromDashboard/UserGroupfromDashboard";
import StudentGroupEdit from "../StudentGrouph/StudentGroupEdit";
import CreateGroups from "../UserGroups/CreateGroupFromDashboard/CreateGroupFromDashboard";
import CreateRoleDashboard from "../CreateRole/CreateRoleDashboard/CreateRoleDashboard";
import NewCreateRole from "../CreateRole/NewCreateRole/NewCreateRole";
import UpdatedCreateRole from "../CreateRole/UpdatedCreateRole/UpdateCreateRole";
import UpdatedAssignUserToRole from "../AssignUserToRole/UpdatedAssignToRole/UpdatedAssignToRole";
import UserDashboard from "../UpdatedUserGroups/UserGroupManagementDashboards/UserDashboard";
import CreateUserGroups from "../UpdatedUserGroups/CreateUserGroup/CreateUserGroups";
import UserGroupsDashboard from "../UserGroups/UpdatedUserGroupsDashboard/UserGroupsDashboard"
import UpdatedCreateUserGroup from "../UserGroups/UpdatedCreateUserGroup/UpdatedCreateUserGroup";
import ManageGroupAccess from "../UpdatedUserGroups/ManageGroupAccess/ManageGroupAccess";
import ManageGroupEmployee from "../UserGroups/ManageGroupEmployee/ManageGroupEmployee";
import UserGroupRoleAccess from "../UserGroups/UserGroupRoleAccess/UserGroupRoleAccess";
import UserGroupDetails from "../UserGroups/UserGroupDetails/UserGroupDetails";
import NotificationConfigDashboard from "../NotificationConfiguration/NotificationConfigurationDashboard/NotificationConfigDashboard";
import NotificationConfigurationStudentAttendence from "../NotificationConfiguration/NotificationConfigurationStudentAttendence/NotificationConfigurationStudentAttendence";
import { use } from "react";
import ImportQuestions from "../ImportQuestions/ImportQuestions";
import DPPApprovalDashboard from "../CreateQuestionsPaper/DPPApproval/DPPApprovalDashboard";
import TestApprovalDashboard from "../CreateQuestionsPaper/TestApproval/TestApprovalDashboard";
import TestApproval from "../CreateQuestionsPaper/TestApproval/TestApproval";
import DPPApproval from "../CreateQuestionsPaper/DPPApproval/DPPApproval";

import useBreadcrumb from "../../Utils/useBreadcrumb";
import BreadcrumbNav from "../../Components/BreadcrumbNav/BreadcrumbNav";
import "../../Components/BreadcrumbNav/BreadcrumbNav.css";
import TipDashboard from "../TipInventory&Status/TipOfDaysDashboard/TipDashboard";
import ScheduleTipsOfDays from "../TipInventory&Status/ScheduleTipsOfDays/ScheduleTipsOfDays";
import McqOfTheDay from "../CreateQuestionsPaper/McqOfTheDay/McqOfTheDay";
import MCQDayDashboard from "../CreateQuestionsPaper/McqOfTheDay/MCQDayDashboard";
import McqOfTheDayEdit from "../CreateQuestionsPaper/McqOfTheDay/McqOfTheDayEdit";
import SendNotification from "../SendNotifications/SendNotification";

function Landing({ setAuthenticated, setIsLoggedOut }) {
  const navigate = useNavigate();

  const [messageBox, setMessageBox] = useState("this message box");
  const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
  const [messageBoxHeight, setMessageBoxHeight] = useState("10vh"); // default height
  const [noTimeSet, setNoTimeSet] = useState(false);
  const [imgActive, setActiveImg] = useState();
  const [selectedStudentId, setSelectedStudentID] = useState("");
  const [loaderOrNot, setLoaderOrNot] = useState(false);

  // const [messageBox, setMessageBox] = useState("this message box");
  // const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
  // const [imgActive, setActiveImg] = useState();
  const timerRef = useRef(null); // Timer reference
  const [isBlockerEnabled, setIsBlockerEnabled] = useState(true);

  const { pagePath, breadcrumbSegments, setPagePath } = useBreadcrumb();

  useEffect(() => {
    const handleSecurityToggle = (e) => {
      if (e.altKey && e.key.toLowerCase() === "a") {
        setIsBlockerEnabled((prev) => !prev);
        // Show feedback in message box
        // setMessageBox(`Security measures ${!isBlockerEnabled ? 'enabled' : 'disabled'}`);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Security measures : {!isBlockerEnabled ? "enabled" : "disabled"}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(Success);
        e.preventDefault(); // Prevent default Alt+A behavior
      }
    };

    document.addEventListener("keydown", handleSecurityToggle);
    return () => document.removeEventListener("keydown", handleSecurityToggle);
  }, [isBlockerEnabled, setMessageBox, setIsMessageBoxVisible]);

  // ADDED THE LOGIC TO STAY MESSAGE BOX ON SCREEN
  useEffect(() => {
    if (isMessageBoxVisible) {
      pauseTimer(); // clear any existing timer
      if (!noTimeSet) {
        timerRef.current = setTimeout(() => {
          setIsMessageBoxVisible(false);
        }, 3500); // auto-close after 3.5s
      }
    }
    return () => clearTimeout(timerRef.current);
  }, [isMessageBoxVisible, noTimeSet]);

  // Timer management
  const startTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current); // Clear any existing timer before starting a new one
    }
    if (!noTimeSet) {
      timerRef.current = setTimeout(() => {
        setIsMessageBoxVisible(false);
      }, 3500); // Timer duration (3 seconds)
    }
  };

  const pauseTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current); // Clear the timer to pause
    }
  };

  const resumeTimer = () => {
    startTimer(); // Resume the timer by starting it again
  };

  useEffect(() => {
    if (isMessageBoxVisible) {
      startTimer(); // Start the timer when the message box is shown
    }
  }, [isMessageBoxVisible]);

  const handleMessageChange = (event) => {
    setMessageBox(event.target.value);
    setIsMessageBoxVisible(true);
  };
  // const [pagePath, setPagePath] = useState("");
  // const [routes, setRoutes] = useState([]);
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebarMAIN = () => {
    setIsOpen(!isOpen);
  };

  // const [pagePath, setPagePath] = useState(() => {
  //   return localStorage.getItem("pagePath") || "Home";
  // });
  const [routes, setRoutes] = useState([]);

  // // Save pagePath to localStorage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem("pagePath", pagePath);
  // }, [pagePath]);

  // useEffect(() => {
  //   // Save pagePath to localStorage whenever it changes
  //   localStorage.setItem("pagePath", pagePath);
  // }, [pagePath]);

  // console.log("routes", routes);

  //redux store
  const { data } = useSelector((state) => state.landing);

  const dispatch = useDispatch();

  useEffect(() => {
    const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
    const clientId = localStorage.getItem("clientId") || sessionStorage.getItem("clientId");
    const clientBranchId = localStorage.getItem("clientBranchId") || sessionStorage.getItem("clientBranchId");
    // const clientBranchId =
    //   localStorage.getItem("clientBranchId") || sessionStorage.getItem("clientBranchId");
    // if (userId && clientId && clientBranchId) {
    //   dispatch(fetchApiData({ userId, clientId, clientBranchId }));
    // }
    if (userId && clientId && clientBranchId) {
      dispatch(fetchApiData({ userId, clientId, clientBranchId }));
    }
  }, [dispatch]);

  // const dynamicLogoPath = "dsc_bpl.png";
  // console.log("landing new data :::", data)
  const dynamicLogoPathOne = data ? `${data.client_schema_name[7]}.png` : "";
  // const dynamicLogoPathOne = "dsc_bpl.png";

  const institute_name = "Definite Success Classes";
  const branch_name = "Kasturba Nagar, Bhopal";
  // if (data){
  //   console.log("branch_name", data.client_schema_name[6][0].br_display_name)
  // }

  const dynamicBranchName = data && data.client_schema_name?.[6]?.[0]?.br_display_name;


  // sidebar resize
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  useEffect(() => {
    // Define the media query
    const mediaQuery = window.matchMedia("(max-width: 1200px)");

    // Function to toggle the sidebar visibility based on the media query
    const handleMediaQueryChange = (event) => {
      setSidebarVisible(!event.matches);
    };

    // Add the listener for media query changes
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    // Call the handler right away so state gets updated with the initial value
    handleMediaQueryChange(mediaQuery);

    // Remove the listener on cleanup
    return () =>
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, []);
  //////////////searchbar code
  const [searchKey, setSearchKey] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  useEffect(() => {
    const handleSearch = async () => {
      if (searchKey && searchKey.length >= 3) {
        try {
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-search-key/?search_key=${searchKey}`,
            {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            }
          );
          const data = await response.json();
          setSearchResults(data);
        } catch (error) {
          console.error(error);
        }
      } else {
        setSearchResults([]); // Clear the search results when searchKey is empty
      }
    };

    handleSearch();
  }, [searchKey]); // This will run the effect when `searchKey` changes

  // useEffect(() => {
  //   const handleUnload = () => {
  //     // Clear specific item from local storage
  //     localStorage.setItem("pagePath", "Home");

  //     // Or clear all local storage
  //     // localStorage.clear();

  //     // console.log('Local storage cleared.');
  //   };

  //   window.addEventListener("unload", handleUnload);

  //   // Cleanup event listener on component unmount
  //   return () => {
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);

  // Dynamically create elements based on the ui_element string
  const createElement = (componentName, props = {}) => {
    const components = {
      EmployeeRegistration,
      StudentRegistration,
      AssignDPP,
      UserReg,
      CreateRole,
      AssignUserToRole,
      UploadQuestions,
      CreateBatch,
      GenerateOTLC,
      NewTestSeries,
      UOD,
      QuestionPaperCorrection,
      CreateBatchV2,
      AttendanceReport,
      AssignTest,
      TestCreate,
      UserManagement,
      TimeTable,
      StudentFees,
      ReportManagement,
      ReportCard,
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      StudentDashBoard,
      NTSV2,
      ReviewQuestion,
      LevelReview,
      PublishSingleQuestion,
      HodReview,
      HoDv2Dashboard,
      TestScheduling,
      DashboardCreateQuestionpaper,
      TSD,
      FacultyReview,
      DppScheduling,
      QuestionBankReview,
      ParseDeleteQuestionDashboard,
      TESTRQ,
      ParseQuestionDashboard,
      QuestionSecondPage,
      TestReportCard,
      DppBatchSubwiseStatus,
      ReportWhatsapp,
      DPPPerformance,
      DPPSubjectCount,
      Facultyv2Dashboard,
      ClassFeedback,
      DPPSummary,
      CreateTestSection,
      TestSectionManagement,
      ParseBulkQuestion,
      ReviewerDashboard,
      HoDDashboard,
      QuestionBank,
      CreateQuesPaper,
      QuestionPaperDetail,
      DPPDashboardSchedule,
      // DPPScheduleClone,
      DPPScheduleEdit,
      TestDashboardSchedule,
      TestPaperBonusCorrection,
      AssignorDashbord,
      ReviewerQuesPaperDashboard,
      TestScheduleview,
      RevieweQuestionPaper,
      TestResultDashboard,
      UploadOmrV2,
      UserDashboard,
      StudentGroupDashboard,
      CreateRoleDashboard,
      UserGroupsDashboard,
      NotificationConfigDashboard,
      ImportQuestions,
      TipDashboard,
      SendNotification,
      MCQDayDashboard,
      DPPApprovalDashboard,
      TestApprovalDashboard,
    };

    const Component = components[componentName];
    return Component ? (
      <Component
        {...props}
        setMessageBox={setMessageBox}
        messageBox={messageBox}
        setIsMessageBoxVisible={setIsMessageBoxVisible}
        setActiveImg={setActiveImg}
      />
    ) : null;
  };

  // const handleSelectStudentId = (studentID) => {
  //   setSelectedStudentID(studentID);
  // };

  const handleSelectStudentId = (studentID) => {
    setSelectedStudentID(studentID);
    navigate("/student_dashboard"); // <-- This will route the user
  };

  return (
    <div className="main">
      {isBlockerEnabled && <BlockerZ />}
      <div className="main-one">
        {/* LOGO */}
        <div style={{}}>
          <Link to="/" onClick={() => setPagePath("Home")}>
            <div>
              {/* <img
                src={
                  process.env.PUBLIC_URL + `/client_logos/${dynamicLogoPathOne}`
                }
                alt="DSC Bhopal Logo"
                className="ds-logo-navbar"
              /> */}
              <img
                src={ LogoOfPrism }
                alt="Power Prep Logo"
                className="ds-logo-navbar"
              />
            </div>
          </Link>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {/* BRANCH */}
          <div
            style={
              {
                // backgroundColor:"yellow"
              }
            }
          >
            <div className="branch-div-landing">
              <div
                style={{
                  fontSize: "30px",
                  marginBottom: "5px",
                  marginTop: "-11px",
                  marginLeft:"-22px",
                  fontWeight: "700",
                }}
              >
                {institute_name}
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <img
                  style={{ height: "24px", width: "24px" ,   marginLeft:"-25px",}}
                  src={LocationIcon}
                  alt="location"
                />
                <BranchDropdown text={dynamicBranchName} />
              </div>
            </div>
          </div>

          {/* ICONS AND AVATARS */}
          <div style={{}}>
            <div className="icons">
              <div className="iconOne">
                <div className="notificationDotOne">
                  {data && data.client_schema_name[4]}
                </div>
              </div>
              <div className="iconTwo">
                <div className="notificationDotTwo">
                  {data && data.client_schema_name[3]}
                </div>
              </div>
              <div className="iconThree">
                <HelpDropdown />
              </div>
              <div className="">
                <Dropdown
                  setAuthenticated={setAuthenticated}
                  setPagePath={setPagePath}
                  setIsLoggedOut={setIsLoggedOut}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-two">
        {/* <div className="subone">
          <ItemPathFilter />
        </div> */}
        {sidebarVisible && (
          <Sidebar setPagePath={setPagePath} setRoutes={setRoutes} />
        )}

        <div className="subtwo">
          <button className="togglebtn" onClick={toggleSidebar}>
            . <br /> . <br /> .
          </button>
          <div className="subtwoa lan-flex">
            <div className="My-fav-dropdwon">
              <Favorites setPagePath={setPagePath} />
            </div>
            <div className="subtwoa-2">
              {/* <input className="searchbar-landing" type="text" placeholder=" Search" /> <img style={{height: "px" , width: "1vw"}} src={Search} alt="" /> */}
              {/* ///////////////////////// */}
              {/* <SearchBarStudent /> */}
              <SearchBarStudent onSelectStudentID={handleSelectStudentId} />
              {/* <div className="searchbar-container">
                <input
                  type="text"
                  placeholder="Type here to search"
                  name="search"
                  className="searchbar-landing"
                  onChange={(e) => setSearchKey(e.target.value)}
                  onFocus={() => setIsDropdownVisible(true)}
                  onBlur={() =>
                    setTimeout(() => setIsDropdownVisible(false), 200)
                  }
                />
                <img
                  src={Search}
                  className="searchbar-img-landing"
                  alt="addition"
                />
                {isDropdownVisible && searchResults.length > 0 && (
                  <div className="search-results-dropdown">
                    {searchResults.map((result, index) => (
                      <div key={index} className="search-result-item">
                        <p className="first-item-student">
                          {" "}
                          <img
                            src={StudentLogo}
                            style={{
                              height: "25px",
                              width: "25px",
                              marginRight: "4px",
                            }}
                            alt=""
                          />
                          {result.student_full_name}
                        </p>
                        <p
                          style={{ marginTop: "5px" }}
                          className="second-item-student"
                        >
                          {" "}
                          Batch: {result.batch_name}
                        </p>

                        <p className="second-item-student">
                          {" "}
                          Roll No: {result.roll_number}{" "}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div> */}
            </div>
            {/* ///////////////////////// */}
          </div>
          {/* {isMessageBoxVisible && (
            <div className="Messages-For-All">
              <div className="Message-Contents">
                <div style={{ display: "flex", gap: "5px" }}>
                  {loaderOrNot ? (
                    <div className="loader"></div>
                  ) : (
                    <img
                      className="Active-image-messagebox"
                      style={{ width: "20px", height: "20px" }}
                      src={imgActive}
                      alt=""
                    />
                  )}

                  <p>{messageBox}</p>
                </div>
              </div>
            </div>
          )} */}
          {isMessageBoxVisible && (
            <div
              className="Messages-For-All"
              onMouseEnter={pauseTimer} // Pause the timer on hover
              onMouseLeave={resumeTimer} // Resume the timer when leaving the box
            >
              {/* <div className="Message-Contents"> */}
              <div
                className="Message-Contents"
                style={{ height: messageBoxHeight }}
              >
                <div style={{ display: "flex", gap: "5px" }}>
                  {loaderOrNot ? (
                    <div className="loader"></div>
                  ) : (
                    // <img
                    //   className="Active-image-messagebox"
                    //   style={{ width: "20px", height: "20px" }}
                    //   src={imgActive}
                    //   alt=""
                    // />
                    <img
                      className="Active-image-messagebox"
                      style={{
                        width: "20px",
                        height: "20px",
                        ...(imgActive ? {} : { display: "none" }), // Hide the image if imgActive is falsy
                      }}
                      src={imgActive || ""} // Use an empty string as a fallback src
                      alt=""
                    />
                  )}
                  <p>{messageBox}</p>
                </div>
              </div>
            </div>
          )}

          {/* ///////////////////////// */}
          <div className="subtwob lan-flex">
            <div className="subtwob-1">
              {/* Administration {">"} Question Bank {">"} Manual Entry */}
              {/* {pagePath} */}
              <BreadcrumbNav segments={breadcrumbSegments} />
            </div>
            <div className="subtwob-2">{/* <ActionButton /> */}</div>
          </div>
          <div className="subtwoc">
            {/* <img src={img} alt="" style={{ width: "300px", height: "300px" }} /> */}

            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/student_registration"
                element={
                  <StudentRegistration
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/employee_registration"
                element={
                  <EmployeeRegistration
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                  />
                }
              />
              <Route
                path="/user_settings"
                element={
                  <UserSettings
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/profile"
                element={
                  <Profile
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                    setPagePath={setPagePath}
                    setIsLoggedOut={setIsLoggedOut}
                    setAuthenticated={setAuthenticated}
                  />
                }
              />
              {/* <Route
                path="/employee_registration"
                element={<EmployeeRegistration />}
              />
              <Route
                path="/student_registration"
                element={<StudentRegistration />}
              />
              <Route
                path="/assign_test"
                element={<Assigntest dataClient={data} />}
              /> */}

              {/* <Route
                path="/user_registration"
                element={<UserReg dataClient={data} />}
              /> */}
              {/* 
              <Route
                path="/user_registration"
                element={<UserReg dataClient={data} />}
              />
              <Route
                path="/create_role"
                element={<CreateRole dataClient={data} />}
              />
              <Route
                path="/assign_user_to_role"
                element={<AssignUserToRole dataClient={data} />}
              />
              <Route path="/upload_answer" element={<UploadQuestions />} />

              <Route path="/create_batch" element={<CreateBatch />} /> */}
              {/* <Route path="/schedule_test" element={<AssignTest />} />  */}
              {/* <Route path="/attendance_report" element={<AttendanceReport />} /> */}
              {/* <Route path="/NewTestSeries" element={<NewTestSeries dataClient={data}/>} /> */}
              {/* <Route path="/upload_omr_data" element={<UOD />} /> */}
              {/* <Route path="/Assign_batch" element={<CreateBatchV2 />} />                              */}
              {/* <Route path="/time_table" element={<TimeTable />} /> */}
              {/* <Route path="/user_management" element={<UserManagement />} /> */}
              <Route
                path="/pop"
                element={
                  <Pop
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/student_dashboard"
                element={
                  <StudentDashBoard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    selectedStudentID={selectedStudentId}
                  />
                }
              />
              <Route
                path="/review_question_paper"
                element={
                  <RevieweQuestionPaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    selectedStudentID={selectedStudentId}
                  />
                }
              />
              <Route
                path="/testscheduling"
                element={
                  <TestScheduling
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    selectedStudentID={selectedStudentId}
                  />
                }
              />
              <Route
                path="/ntsv2"
                element={
                  <NTSV2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/tsd"
                element={
                  <TSD
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/pop2"
                element={
                  <POP2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/DashboardCreateQuestionpaper"
                element={
                  <DashboardCreateQuestionpaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/otc"
                element={
                  <GenerateOTLC
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/pop3"
                element={
                  <POP3
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/level_review"
                element={
                  <LevelReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/user_groups_dashboard"
                element={
                  <UserGroupsDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              {/* <Route
                path="/user_groups_from_dashboard"
                element={
                  <UserGroupsFromDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/faculty_review"
                element={
                  <FacultyReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/dpp_scheduling"
                element={
                  <DppScheduling
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_from_dashboard_edit"
                element={
                  <UserEditFromDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/user_dashboard"
                element={
                  <UserDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/Test_scheduling_dashboard"
                element={
                  <TestDashboardSchedule
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/dpp_scheduling_edit"
                element={
                  // <DPPScheduleClone
                  <DPPScheduleEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/dppdashboardschedulev2"
                element={
                  <DPPDashboardSchedulev2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/hodv2_dashboard"
                element={
                  <HoDv2Dashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_bank_review"
                element={
                  <QuestionBankReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/hod_review"
                element={
                  <HodReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />

              <Route
                path="/set_dashboard"
                element={
                  <ParseQuestionDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/ques_dashboard"
                element={
                  <ParseDeleteQuestionDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_review"
                element={
                  <ReviewQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/TESTRQ"
                element={
                  <TESTRQ
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/publish_single_question"
                element={
                  <PublishSingleQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_review"
                element={
                  <ReviewQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/questionsecondpage"
                element={
                  <QuestionSecondPage
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/generate_result"
                element={<GenerateResult dataClient={data} />}
              />
              <Route
                path="/report_management"
                element={
                  <ReportManagement
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                  />
                }
              />
              <Route
                path="/test_report_card"
                element={
                  <TestReportCard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/test_paper_bonus_correction"
                element={
                  <TestPaperBonusCorrection
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/DPP_Batch_Sub_Status"
                element={
                  <DppBatchSubwiseStatus
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/DPP_Dashboard_Schedule"
                element={
                  <DPPDashboardSchedule
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="question_paper_dashboard"
                element={
                  <QuestionPaperDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="report_whatsapp"
                element={
                  <ReportWhatsapp
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/Student_DPP_Performance"
                element={
                  <DPPPerformance
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/Batch_Sub_DPP_Count"
                element={
                  <DPPSubjectCount
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                  />
                }
              />
              <Route
                path="/faculty_v2_dashboard"
                element={
                  <Facultyv2Dashboard
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                  />
                }
              />
              <Route
                path="/class_feedback"
                element={
                  <ClassFeedback
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                  />
                }
              />
              <Route path="/report_card" element={<ReportCard />} />
              {/* {routes.map(({ ui_path, ui_element }) => (
                console.log(ui_path,ui_element)
              ))} */}
              {/* {routes.map(({ ui_path, ui_element }) => (
                <Route
                  key={ui_path}
                  path={ui_path}
                  element={createElement(ui_element, { dataClient: data })}
                  setMessageBox={setMessageBox}
                  messageBox={messageBox}
                  setIsMessageBoxVisible={setIsMessageBoxVisible}
                  setActiveImg={setActiveImg}
                  setLoaderOrNot={setLoaderOrNot}
                />
              ))} */}
              {routes.map(({ ui_path, ui_element }) => (
                <Route
                  key={ui_path}
                  path={ui_path}
                  element={createElement(ui_element, {
                    dataClient: data,
                    setMessageBox,
                    messageBox,
                    setIsMessageBoxVisible,
                    setActiveImg,
                    setLoaderOrNot,
                    setPagePath,
                  })}
                />
              ))}

              {/* <Route
                path="/dpp_batch_subwise_status"
                element={<DppBatchSubwiseStatus dataClient={data} />}
              /> */}
              <Route
                path="/dppstatus"
                element={
                  <DPPSummary
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                  />
                }
              />
              <Route
                path="/test_section"
                element={
                  <CreateTestSection
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/test_section_management"
                element={
                  <TestSectionManagement
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/parse_bulk_questions"
                element={
                  <ParseBulkQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/reviewer_dashboard"
                element={
                  <ReviewerDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/hod_dashboard"
                element={
                  <HoDDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/TestScheduleview"
                element={
                  <TestScheduleview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />

              <Route
                path="/questionbank"
                element={
                  <QuestionBank
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/upload_omr_data_v2"
                element={
                  <UploadOmrV2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                    pauseTimer={pauseTimer}
                  />
                }
              />
              <Route
                path="/curate_ques_paper"
                element={
                  <CreateQuesPaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_paper_details"
                element={
                  <QuestionPaperDetail
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    setMessageBoxHeight={setMessageBoxHeight}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/assignor_dashboard_details"
                element={
                  <AssignorDashbord
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/curate_question_paper_edit"
                element={
                  <CurateQuestionPaperEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/reviewer_ques_paper_dashboard"
                element={
                  <ReviewerQuesPaperDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/preview_ques_paper"
                element={
                  <PreviewQuesPaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/test_result_dashboard"
                element={
                  <TestResultDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />

              {/* <Route
                path="/create_groups_from_dashboard"
                element={
                  <CreateGroups
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              /> */}
               <Route
                path="/student_group_dashboard"
                element={
                  <StudentGroupDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/student_group"
                element={
                  <StudentGroup
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/student_group_edit"
                element={
                  <StudentGroupEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/create_role_dashboard"
                element={
                  <CreateRoleDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/new_create_role"
                element={
                  <NewCreateRole
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/update_create_role"
                element={
                  <UpdatedCreateRole
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/update_assign_user_to_role"
                element={
                  <UpdatedAssignUserToRole
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/user_dashboard"
                element={
                  <UserDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
                <Route
                path="/updated_user_group"
                element={
                  <CreateUserGroups
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               {/* <Route
                path="/updated_user_groups_dashboard"
                element={
                  <UpdatedUserGroupsDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/user_groups_dashboard"
                element={
                  <UserGroupsDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/updated_create_user_group"
                element={
                  <UpdatedCreateUserGroup
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/manage_group_access"
                element={
                  <ManageGroupAccess
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_group_role_access"
                element={
                  <UserGroupRoleAccess
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_group_details"
                element={
                  <UserGroupDetails
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/manage_group_employee"
                element={
                  <ManageGroupEmployee
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
             <Route
                path="/notification_config_dashboard"
                element={
                  <NotificationConfigDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/configuration_notification_student_attendence"
                element={
                  <NotificationConfigurationStudentAttendence
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/import_questions"
                element={
                  <ImportQuestions
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/dpp_approval_dashboard"
                element={
                  <DPPApprovalDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/dpp_approval"
                element={
                  <DPPApproval
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
               <Route
                path="/test_approval_dashboard"
                element={
                  <TestApprovalDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/test_approval"
                element={
                  <TestApproval
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />

              <Route
                path="/mcq_of_day"
                element={
                  <McqOfTheDay
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/mcq_dashboard"
                element={
                  <MCQDayDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/mcq_of_day_edit"
                element={
                  <McqOfTheDayEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/tip_dashboard"
                element={
                  <TipDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/schedule_tips_of_days"
                element={
                  <ScheduleTipsOfDays
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/send_notification"
                element={
                  <SendNotification
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
            </Routes> 
            <p className="landing-dse-sign">Powered by DSE Infotech</p>
            {/* <p className="landing-dse-sign"><img src={CoachingBuddyImg} alt="" /></p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;